import { useNavigate } from "react-router-dom";
import { PatientSearchResult } from "@/dentlab/src/store/Search/types";
import { PatientEntityType } from "../../../../lib/supabase/supabaseTypes";

export const PatientItemComponent = ({
	patient,
}: {
	patient: PatientSearchResult | PatientEntityType;
}) => {
	const navigate = useNavigate();

	const name = `${patient.title ?? ""} ${patient.first_name ?? ""} ${patient.last_name ?? ""}`;

	return (
		<>
			<div
				onClick={() => {
						navigate(`/patient/${patient.id}`);
				}}
				className="p-2 bg-blue-100 rounded cursor-pointer transition-colors active:bg-blue-200"
			>
				<div className="text-lg">{name}</div>
				<div className=" text-gray-500 text-sm">{patient.code}</div>
			</div>
		</>
	);
};
